import React from 'react';
import Button from 'atoms/Button/Button';
import Stack from 'atoms/Layout/Stack/Stack';
import Typography from 'atoms/Typography/Typography';
import CheckItemTextListWithActions from 'molecules/CheckItemTextList/CheckItemTextListWithActions';
import HeadingAndSupportingTextWithActions from 'molecules/HeadingAndSupportingText/HeadingAndSupportingTextWithActions';

const BehindResultsTextBlock = (): JSX.Element => {
  const renderButton = () => (
    <Stack
      justify='flex-start'
      align='center'
      maxWidth='width-fit-content'
    >
      <Button
        size='xl'
        variant='primary'
        href='https://cohost.mn.co/?plan=free-trial'
      >
        Try Mighty for Free
      </Button>
    </Stack>
  );

  const renderActions = () => (
    <Stack
      direction='column'
      marginTop='spacing-4xl'
    >
      <CheckItemTextListWithActions
        checkItemTextListProps={{
          checkItems: [
            "<b>Native mobile apps</b> you won't find anywhere else.",
            '<b>Community Design™</b> our proven strategy framework that drives our product and AI.',
            '<b>Member engagement</b> that dwarfs other platforms.',
          ],
          checkItemProps: {
            size: 'lg',
            type: 'default',
            color: 'primary',
          },
        }}
        actions={renderButton()}
      />
    </Stack>
  );

  return (
    <HeadingAndSupportingTextWithActions
      direction='column'
      gap='spacing-2xl'
      heading={{
        type: 'heading',
        size: 'xl',
        text: 'Build a community people love',
      }}
      supportingText={{
        type: 'paragraph',
        size: 'lg',
        color: 'text-primary',
        children: (
          <Stack
            direction='column'
            gap='spacing-lg'
            as='span'
          >
            <Typography
              as='span'
              text="We call our customers hosts—because you're not just creating content on Mighty, you're bringing people together."
            />
            <Typography
              as='span'
              text='The Mighty Difference:'
            />
          </Stack>
        ),
      }}
      actions={renderActions()}
    />
  );
};

export default BehindResultsTextBlock;
